<template>
  <v-container fluid class="payee-list-page pa-0">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    />

    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editPayee="selectedPayee"
    />

    <v-card :loading="loading" outlined class="payee-list-card">
      <div class="payee-list-header">
        <div>
          <div class="page-title">Payee</div>
          <div class="page-subtitle">
            {{ payees.length }} payee{{ payees.length === 1 ? "" : "s" }} found
          </div>
        </div>

        <v-btn
          v-if="checkRightStatus(2)"
          small
          rounded
          color="primary"
          dark
          @click="add"
        >
          <v-icon left small>mdi-plus</v-icon>
          New Payee
        </v-btn>
      </div>

      <div class="payee-filter-bar">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          autofocus
          dense
          label="Search payee"
          single-line
          hide-details
          clearable
          class="payee-search"
        />
      </div>

      <v-card-text class="pa-4">
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="payees"
          :search="search"
          :loading="loading"
          :sort-by="sortBy"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="payee-table"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer payee-row">
              <td class="text-left font-weight-bold">
                {{ item.name || "Unknown Payee" }}
              </td>

              <td class="text-left">
                {{ item.phoneNumber || "--" }}
              </td>

              <td class="text-left">
                {{ item.email || "--" }}
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon small>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="menu-button">
                    <v-list-item
                      v-if="checkRightStatus(18)"
                      @click="editPayee(item)"
                    >
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="checkRightStatus(10)"
                      @click="deletePayee(item)"
                    >
                      <v-list-item-title class="red--text">
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import payeeService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "payee-list",

  components: {
    Create,
    Edit,
  },

  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedPayee: null,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Phone Number",
          align: "left",
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: "Email Address",
          value: "email",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      payees: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },

  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },

  created() {
    this.getList();
    document.title = "smplsale - Payee List";
  },

  methods: {
    add() {
      this.createDialog = true;
    },

    async getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;

      try {
        const response = await payeeService.getAll();
        this.payees = response.data || [];
        return response;
      } catch (error) {
        console.error("payee getList failed", error);
        this.payees = [];
      } finally {
        this.loading = false;
      }
    },

    editPayee(payee) {
      this.selectedPayee = payee;
      this.editDialog = true;
    },

    deletePayee(payee) {
      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.deletePrecaution
      ) {
        this.$swal
          .fire({
            title: "Are you sure?",
            html: `You won't be able to revert this.</br> <div style="color:red;">Type <span style="font-weight: bold">delete</span> in order remove this</div>`,
            icon: "question",
            input: "text",
            inputAttributes: {
              autocapitalize: "off",
            },
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
          })
          .then((result) => {
            if (result.value && result.value === "delete") {
              payeeService.delete(payee.id).then((response) => {
                if (response.data) {
                  this.$swal("Deleted!", "Payee has been deleted.", "success");
                  this.getList();
                }
              });
            } else if (result.dismiss === "cancel") {
            } else {
              this.$swal("Delete", 'Type "delete" to delete item', "error");
            }
          });
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            payeeService.delete(payee.id).then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Payee has been deleted.", "success");
                this.getList();
              }
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.payee-list-page {
  background: #f8fafc;
}

.payee-list-card {
  border-radius: 20px;
  background: #ffffff;
}

.payee-list-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.page-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.payee-filter-bar {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.payee-search {
  max-width: 340px;
  min-width: 260px;
}

.payee-table {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.payee-row:hover {
  background: #f8fafc;
}

@media (max-width: 600px) {
  .payee-search {
    max-width: 100%;
    min-width: 100%;
  }

  .payee-list-header {
    align-items: flex-start;
  }
}
</style>